export interface Balanza {
  id: number;
  laboratorio_id: number;
  capacidad: number; //double (2)
  precision: number;
}

export function createEmptyBalanza(): Balanza {
  return {
    id: null,
    laboratorio_id: null,
    capacidad: null,
    precision: null
  };
}

export function createBalanza(params: any): Balanza {
  return {
    ...createEmptyBalanza(),
    ...params
  };
}
